<template>
  <div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="币种">
        <el-select size="small" v-model="formInline.tokenName" placeholder="请选择">
          <el-option v-for="item in typeToken" :label="item.key" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" sortable prop="userName" label="用户名" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="tokenName" label="币种" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="amount" label="数量" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="fee" label="手续费" min-width="100">
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 'checking'">
              <el-tag size="medium" type="warning" Plain>等待审核</el-tag>
              <span>操作</span>
              <el-button size="mini" type="success" @click="onAudit(scope.row)">去审核</el-button>
            </div>
            <div v-if="scope.row.status == 'waiting'"><el-tag  type="warning" size="medium" Plain>等待</el-tag></div>
            <div v-if="scope.row.status == 'pending'"><el-tag size="medium" Plain>已发送</el-tag></div>
            <div v-if="scope.row.status == 'success'"><el-tag type="success" size="medium" Plain>成功</el-tag></div>
            <div v-if="scope.row.status == 'failed'">
              <el-tag type="danger" size="medium" Plain>失败</el-tag>
              <!-- <div>操作</div> -->
              <el-button size="mini" type="warning" @click="onFailed(scope.row,1)">重试</el-button>
              <el-button size="mini" type="success" @click="onFailed(scope.row,2)" class="pdleft">退回</el-button>
            </div>
            <div v-if="scope.row.status == 'back'"><el-tag size="medium" Plain>退回中</el-tag></div>
            <div v-if="scope.row.status == 'cancel'"><el-tag size="medium">已取消</el-tag></div>
            <div v-if="scope.row.status == 'warning'"><el-tag size="medium">异常</el-tag></div>
          </template>
      </el-table-column>
      <el-table-column align="center" prop="toAddr" label="收款地址" min-width="200">
        <template slot-scope="scope">
          <div :title="scope.row.toAddr">
            {{ scope.row.toAddr.slice(0,6)+'……'+scope.row.toAddr.substr(scope.row.toAddr.length-6,6) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="txid" label="Txid" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.txid != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txid" :href="scope.row.url" target="_blank">{{ scope.row.txid.slice(0,6)+'……'+scope.row.txid.substr(scope.row.txid.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="inside" label="提现到内部" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.inside?'是':'否' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div style="text-align: center;" v-if="objInfo">
        <p :class="objInfo.deposit == 0?'cref':''">充 值 了：{{ objInfo.deposit || 0 }} U</p>
        <p :class="objInfo.miner == 0?'cyell':''">购买矿机：{{ objInfo.miner || 0 }} U</p>
        <p>账 户 有：{{ objInfo.balanceU || 0 }} U</p>
        <p>提 现 了：{{ objInfo.withdrawalU || 0 }} U</p>
        <p>兑换G币 ：{{ objInfo.exchangeUToG || 0 }} U</p>
        <p v-if="objInfo.rate >= 0" :class="(objInfo.deposit == 0 || objInfo.rate > 1)?'cref':''">盈亏比例：{{objInfo.deposit == 0?'空手套白狼 '+(objInfo.balanceU+objInfo.miner+objInfo.withdrawalU+objInfo.exchangeUToG)+' U':objInfo.rate*100+'%'}}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="goAudit('reject')">审核拒绝</el-button>
        <el-button type="success" plain @click="goAudit('pass')">审核通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { withdrawList , withdrawCheck , withdrawBackRetry , activeWithdrawUser,WithdrawUserInfo } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      centerDialogVisible:false,
      orderId:null,
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        from: 1,
        limit: 10,
        startTime: "",
        endTime: "",
        tokenName: "",
        userName: ""
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeToken: [
        { key: '请选择', value: '' },
        { key: 'USDT', value: 'USDT' },
        { key: 'ETH', value: 'ETH' },
      ],
      timeVal:"",
      myInfo:{
        address:'',
        trx:'',
        usdt:''
      },
      objInfo:null
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      withdrawList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    // 获取审核数据
    getinfo(id) {
      this.loading = true
      WithdrawUserInfo({uId:id})
        .then(res => {
          this.loading = false
          if (res && res.code == 0) {
            console.log(res)
            this.objInfo = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      console.log(this.timeVal)
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    },
    // 去审核
    onAudit(row){
      this.centerDialogVisible = true
      this.orderId = row.orderId
      this.getinfo(row.uId)
    },
    // 去审核
    goAudit(type){
      this.$confirm((type=='pass'?'审核通过':'审核拒绝')+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.myAudit(type)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    //通过和拒绝审核方法
    myAudit(type){
      this.centerDialogVisible = false
      this.loading = true
      let parm = {
        orderId:this.orderId,
        result:type
      };
      withdrawCheck(parm)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getdata(this.formInline)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('审核操作失败，请稍后再试！')
        })
    },
    onFailed(row,index){
      this.orderId = row.orderId
      this.$confirm((index==1?'重试':'退回')+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.myWithdrawBackRetry(index)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    //重试和退回
    myWithdrawBackRetry(type){
      this.loading = true
      let parm = { orderId:this.orderId };
      withdrawBackRetry(parm,type==1?'WithdrawRetry':'WithdrawBack')
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getdata(this.formInline)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
    },
  }
}
</script>

<style scoped>
.pdleft{
  margin-left: 0;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box-card{
  width: 550px;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}
.box-card .refresh{display: flex;justify-content: flex-end;}
.cref{color: red;}
.cyell{color: rgb(247, 196, 14);}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/Transferout2.vue